module.exports = __webpack_public_path__ + "img/camionnette-avec-remorque.be961f7a.svg";